export const enum UserRole {
  ADMIN = 'admin',
  MIRO = 'miro',
}

export const enum MethodStatus {
  PUBLISHED = 'published',
  DRAFT = 'draft',
}
